module.exports = "https://r.nearpod.com/assets/media/image/AvenirLTStd-Oblique-0b483204f6218a76eafbb7a24a09fbaf.svg";